// import React, { useEffect, useState } from "react";
// import {
//   FiClipboard,
//   FiArrowRight,
//   FiFileText,
//   FiLayers,
//   FiBarChart2,
//   FiUsers,
//   FiClock,
//   FiGrid,
//   FiCheckCircle,
//   FiHome,
//   FiBox,
//   FiSettings,
//   FiDroplet,
//   FiMaximize,
//   FiEdit3,
//   FiMap,

// } from "react-icons/fi";

// const LandingScreen = () => {
//   const [loaded, setLoaded] = useState(false);

//   useEffect(() => {
//     setTimeout(() => setLoaded(true), 150);
//   }, []);

//   const divisions = [
//     { number: "03", name: "Concrete", icon: FiHome },
//     { number: "04", name: "Masonry", icon: FiBox },
//     { number: "05", name: "Metals", icon: FiSettings },
//     { number: "07", name: "Thermal & Moisture", icon: FiDroplet },
//     { number: "08", name: "Openings", icon: FiMaximize,  },
//     { number: "09", name: "Finishes", icon: FiEdit3 },
//     { number: "32", name: "Exterior", icon: FiMap },
//   ];

//   return (
//     <>
//       <style>{`
//         * {
//           box-sizing: border-box;
//         }

//         html {
//           scroll-behavior: smooth;
//         }

//         body {
//           margin: 0;
//           font-family: Arial, Helvetica, sans-serif;
//           background: #f8fbff;
//           color: #10213f;
//         }

//         .sg-hero {
//           position: relative;
//           min-height: 760px;
//           overflow: hidden;
//           background:
//             linear-gradient(
//               90deg,
//               rgba(255,255,255,0.98) 0%,
//               rgba(255,255,255,0.96) 42%,
//               rgba(255,255,255,0.40) 68%,
//               rgba(255,255,255,0.10) 100%
//             ),
//             url("https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=2000&q=90");
//           background-size: cover;
//           background-position: center;
//         }

//         /* Blueprint pattern */
//         .sg-blueprint {
//           position: absolute;
//           inset: 0;
//           pointer-events: none;
//           opacity: 0.32;
//           background-image:
//             linear-gradient(rgba(20,78,150,0.07) 1px, transparent 1px),
//             linear-gradient(90deg, rgba(20,78,150,0.07) 1px, transparent 1px);
//           background-size: 42px 42px;
//           mask-image: linear-gradient(
//             90deg,
//             black 0%,
//             black 35%,
//             transparent 72%
//           );
//         }

//         .sg-blueprint::after {
//           content: "";
//           position: absolute;
//           width: 500px;
//           height: 500px;
//           left: -150px;
//           top: 180px;
//           border: 1px solid rgba(20,78,150,0.12);
//           transform: rotate(15deg);
//         }

//         .sg-hero-inner {
//           position: relative;
//           z-index: 2;
//           width: min(1380px, 92%);
//           min-height: 760px;
//           margin: auto;
//           display: flex;
//           align-items: center;
//           padding: 100px 0 150px;
//         }

//         .sg-content {
//           width: 57%;
//           padding-left: 20px;
//           opacity: 0;
//           transform: translateY(30px);
//           transition: all 0.8s ease;
//         }

//         .sg-content.show {
//           opacity: 1;
//           transform: translateY(0);
//         }

//         .sg-eyebrow {
//           display: inline-flex;
//           align-items: center;
//           gap: 9px;
//           margin-bottom: 22px;
//           padding: 9px 15px;
//           border-radius: 30px;
//           background: rgba(30,92,190,0.08);
//           border: 1px solid rgba(30,92,190,0.13);
//           color: #1455b8;
//           font-size: 13px;
//           font-weight: 700;
//           letter-spacing: 1.2px;
//           text-transform: uppercase;
//         }

//         .sg-eyebrow-dot {
//           width: 8px;
//           height: 8px;
//           border-radius: 50%;
//           background: #f39a18;
//           animation: sgPulse 1.8s infinite;
//         }

//         .sg-title {
//           max-width: 720px;
//           margin: 0;
//           font-size: clamp(48px, 5.3vw, 82px);
//           line-height: 0.99;
//           letter-spacing: -3.5px;
//           font-weight: 800;
//           color: #10213f;
//         }

//         .sg-title span {
//           color: #1d5fc3;
//         }

//         .sg-description {
//           max-width: 650px;
//           margin: 28px 0 32px;
//           color: #53627a;
//           font-size: 18px;
//           line-height: 1.7;
//         }

//         .sg-buttons {
//           display: flex;
//           gap: 14px;
//           flex-wrap: wrap;
//         }

//         .sg-btn {
//           border: none;
//           text-decoration: none;
//           cursor: pointer;
//           display: inline-flex;
//           align-items: center;
//           justify-content: center;
//           gap: 10px;
//           min-height: 54px;
//           padding: 0 25px;
//           border-radius: 9px;
//           font-size: 14px;
//           font-weight: 700;
//           letter-spacing: 0.2px;
//           transition: all 0.25s ease;
//         }

//         .sg-btn-primary {
//           color: white;
//           background: linear-gradient(135deg, #1558c0, #2874dd);
//           box-shadow: 0 12px 30px rgba(27,91,190,0.24);
//         }

//         .sg-btn-primary:hover {
//           transform: translateY(-3px);
//           box-shadow: 0 17px 35px rgba(27,91,190,0.30);
//         }

//         .sg-btn-secondary {
//           color: #1455b8;
//           background: rgba(255,255,255,0.88);
//           border: 1px solid #c9d8ed;
//         }

//         .sg-btn-secondary:hover {
//           transform: translateY(-3px);
//           border-color: #1455b8;
//           background: white;
//         }

//         /* Division chips */
//         .sg-divisions {
//           display: flex;
//           flex-wrap: wrap;
//           gap: 9px;
//           margin-top: 34px;
//           max-width: 700px;
//         }

//         .sg-division {
//           display: flex;
//           align-items: center;
//           gap: 7px;
//           padding: 8px 12px;
//           border: 1px solid rgba(22,74,140,0.13);
//           border-radius: 7px;
//           background: rgba(255,255,255,0.75);
//           color: #35445d;
//           font-size: 12px;
//           font-weight: 600;
//           backdrop-filter: blur(8px);
//         }

//         .sg-division strong {
//           color: #1455b8;
//         }

//         /* Right side */
//         .sg-visual {
//           position: absolute;
//           right: -25px;
//           top: 125px;
//           width: 53%;
//           height: 560px;
//           pointer-events: none;
//         }

//         .sg-visual::after {
//           content: "";
//           position: absolute;
//           right: 4%;
//           bottom: 25px;
//           width: 520px;
//           height: 80px;
//           background: rgba(255,255,255,0.35);
//           filter: blur(28px);
//           border-radius: 50%;
//         }

//         .sg-estimate-card {
//           position: absolute;
//           z-index: 5;
//           top: 60px;
//           left: 0;
//           width: 235px;
//           padding: 20px;
//           border: 1px solid rgba(255,255,255,0.8);
//           border-radius: 18px;
//           background: rgba(255,255,255,0.91);
//           box-shadow: 0 22px 55px rgba(16,43,82,0.17);
//           backdrop-filter: blur(14px);
//           animation: sgFloat 4s ease-in-out infinite;
//         }

//         .sg-card-heading {
//           display: flex;
//           align-items: center;
//           gap: 11px;
//           color: #647188;
//           font-size: 11px;
//           font-weight: 700;
//           letter-spacing: 0.7px;
//           text-transform: uppercase;
//         }

//        .sg-card-icon {
//   width: 38px;
//   height: 38px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   border-radius: 10px;
//   color: white;
//   background: #175bc3;
//   font-size: 19px;
//   flex-shrink: 0;
// }

// .sg-card-icon svg {
//   width: 19px;
//   height: 19px;
//   stroke-width: 2;
// }

//         .sg-card-value {
//           margin-top: 15px;
//           color: #1558c0;
//           font-size: 29px;
//           font-weight: 800;
//         }

//         .sg-card-small {
//           margin-top: 4px;
//           color: #8490a3;
//           font-size: 11px;
//         }

//         .sg-chart {
//           display: flex;
//           align-items: flex-end;
//           gap: 6px;
//           height: 38px;
//           margin-top: 15px;
//         }

//         .sg-chart i {
//           display: block;
//           width: 10px;
//           border-radius: 3px 3px 0 0;
//           background: #2770d5;
//           animation: sgChart 2s ease-in-out infinite alternate;
//         }

//         .sg-chart i:nth-child(1) { height: 12px; }
//         .sg-chart i:nth-child(2) { height: 18px; animation-delay: .1s; }
//         .sg-chart i:nth-child(3) { height: 15px; animation-delay: .2s; }
//         .sg-chart i:nth-child(4) { height: 24px; animation-delay: .3s; }
//         .sg-chart i:nth-child(5) { height: 21px; animation-delay: .4s; }
//         .sg-chart i:nth-child(6) { height: 31px; animation-delay: .5s; }

//         .sg-takeoff-card {
//           position: absolute;
//           z-index: 6;
//           right: 7%;
//           bottom: 80px;
//           width: 215px;
//           padding: 19px;
//           border-radius: 17px;
//           background: rgba(255,255,255,0.94);
//           box-shadow: 0 22px 55px rgba(16,43,82,0.17);
//           backdrop-filter: blur(14px);
//           animation: sgFloat 4.5s ease-in-out infinite;
//           animation-delay: 0.8s;
//         }

//         .sg-orange-icon {
//           background: #f39818;
//         }

//         .sg-takeoff-number {
//           margin-top: 12px;
//           color: #e7870c;
//           font-size: 27px;
//           font-weight: 800;
//         }

//         .sg-progress {
//           height: 7px;
//           margin-top: 14px;
//           border-radius: 20px;
//           overflow: hidden;
//           background: #e8edf4;
//         }

//         .sg-progress span {
//           display: block;
//           width: 88%;
//           height: 100%;
//           border-radius: inherit;
//           background: linear-gradient(90deg, #f39818, #ffbd4d);
//           animation: sgProgress 2.5s ease;
//         }

//         /* Helmet */
//         .sg-helmet {
//           position: absolute;
//           z-index: 4;
//           right: 7%;
//           bottom: 5px;
//           width: 280px;
//           height: 170px;
//           animation: sgHelmet 4s ease-in-out infinite;
//         }

//         .sg-helmet-top {
//           position: absolute;
//           left: 25px;
//           top: 12px;
//           width: 230px;
//           height: 105px;
//           border-radius: 120px 120px 35px 35px;
//           background: linear-gradient(145deg, #fff, #e7edf4);
//           box-shadow:
//             inset -10px -15px 20px rgba(120,140,160,0.18),
//             0 25px 35px rgba(19,47,80,0.22);
//         }

//         .sg-helmet-top::before {
//           content: "";
//           position: absolute;
//           width: 24px;
//           height: 92px;
//           left: 105px;
//           top: 0;
//           border-radius: 50%;
//           border-left: 5px solid #d3dce7;
//           transform: rotate(-5deg);
//         }

//         .sg-helmet-brim {
//           position: absolute;
//           left: 0;
//           bottom: 27px;
//           width: 280px;
//           height: 53px;
//           border-radius: 50%;
//           background: linear-gradient(#f8fafc, #dfe7ef);
//           box-shadow: 0 20px 30px rgba(17,47,81,0.22);
//         }

//         .sg-helmet-logo {
//           position: absolute;
//           z-index: 3;
//           left: 105px;
//           top: 52px;
//           color: #1558c0;
//           font-size: 9px;
//           font-weight: 900;
//           text-align: center;
//           line-height: 1.25;
//         }

//         .sg-helmet-logo::before {
//           content: "▥";
//           display: block;
//           margin-bottom: 2px;
//           font-size: 22px;
//         }

//         /* Calculator */
//         .sg-calculator {
//           position: absolute;
//           z-index: 5;
//           right: -10px;
//           bottom: 0;
//           width: 155px;
//           height: 180px;
//           padding: 15px;
//           border-radius: 12px;
//           background: linear-gradient(145deg, #303945, #151c25);
//           transform: rotate(5deg);
//           box-shadow: 0 25px 40px rgba(15,32,52,0.28);
//         }

//         .sg-calculator-screen {
//           height: 40px;
//           padding: 10px;
//           border-radius: 5px;
//           background: #cbd5b7;
//           color: #273020;
//           text-align: right;
//           font-size: 14px;
//           font-weight: 700;
//         }

//         .sg-calculator-buttons {
//           display: grid;
//           grid-template-columns: repeat(4, 1fr);
//           gap: 5px;
//           margin-top: 10px;
//         }

//         .sg-calculator-buttons span {
//           height: 22px;
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           border-radius: 3px;
//           background: #4a5562;
//           color: white;
//           font-size: 8px;
//         }

//         /* Bottom stats */
//         .sg-stats {
//           position: absolute;
//           z-index: 10;
//           left: 50%;
//           bottom: 25px;
//           transform: translateX(-50%);
//           width: min(1250px, 90%);
//           padding: 20px 25px;
//           display: grid;
//           grid-template-columns: repeat(5, 1fr);
//           gap: 10px;
//           border: 1px solid rgba(213,224,237,0.9);
//           border-radius: 18px;
//           background: rgba(255,255,255,0.93);
//           box-shadow: 0 18px 50px rgba(35,63,96,0.12);
//           backdrop-filter: blur(16px);
//         }

//         .sg-stat {
//           min-height: 55px;
//           padding: 0 15px;
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           border-right: 1px solid #e3e9f1;
//         }

//         .sg-stat:last-child {
//           border-right: none;
//         }

//         .sg-stat-icon {
//           width: 39px;
//           height: 39px;
//           flex-shrink: 0;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           border-radius: 50%;
//           background: #edf4ff;
//           color: #1558c0;
//           font-size: 18px;
//         }

//         .sg-stat strong {
//           display: block;
//           color: #10213f;
//           font-size: 21px;
//         }

//         .sg-stat span {
//           display: block;
//           margin-top: 3px;
//           color: #7b8799;
//           font-size: 10px;
//         }

//         @keyframes sgFloat {
//           0%, 100% {
//             transform: translateY(0);
//           }
//           50% {
//             transform: translateY(-13px);
//           }
//         }

//         @keyframes sgHelmet {
//           0%, 100% {
//             transform: rotate(0deg) translateY(0);
//           }
//           50% {
//             transform: rotate(2deg) translateY(-7px);
//           }
//         }

//         @keyframes sgPulse {
//           0%, 100% {
//             box-shadow: 0 0 0 0 rgba(243,152,24,0.3);
//           }
//           50% {
//             box-shadow: 0 0 0 7px rgba(243,152,24,0);
//           }
//         }

//         @keyframes sgChart {
//           from {
//             opacity: 0.55;
//             transform: scaleY(0.75);
//           }
//           to {
//             opacity: 1;
//             transform: scaleY(1);
//           }
//         }

//         @keyframes sgProgress {
//           from {
//             width: 0;
//           }
//           to {
//             width: 88%;
//           }
//         }

//         @media (max-width: 1100px) {
//           .sg-content {
//             width: 62%;
//           }

//           .sg-visual {
//             opacity: 0.72;
//             right: -150px;
//           }

//           .sg-stats {
//             grid-template-columns: repeat(3, 1fr);
//           }

//           .sg-stat:nth-child(3) {
//             border-right: none;
//           }
//         }

//         @media (max-width: 800px) {
//           .sg-hero {
//             min-height: auto;
//             background:
//               linear-gradient(
//                 180deg,
//                 rgba(255,255,255,0.97) 0%,
//                 rgba(255,255,255,0.91) 60%,
//                 rgba(255,255,255,0.75) 100%
//               ),
//               url("https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=1400&q=85");
//             background-position: center;
//           }

//           .sg-hero-inner {
//             min-height: auto;
//             padding: 80px 0 370px;
//           }

//           .sg-content {
//             width: 100%;
//             padding: 0;
//             text-align: center;
//           }

//           .sg-eyebrow {
//             margin-bottom: 18px;
//           }

//           .sg-title {
//             font-size: clamp(42px, 11vw, 65px);
//             letter-spacing: -2.5px;
//           }

//           .sg-description {
//             margin-left: auto;
//             margin-right: auto;
//             font-size: 16px;
//           }

//           .sg-buttons {
//             justify-content: center;
//           }

//           .sg-divisions {
//             justify-content: center;
//           }

//           .sg-visual {
//             top: auto;
//             right: 0;
//             bottom: 100px;
//             width: 100%;
//             height: 260px;
//             transform: scale(0.72);
//             transform-origin: bottom center;
//             opacity: 0.9;
//           }

//           .sg-estimate-card {
//             left: 5%;
//             top: 20px;
//           }

//           .sg-takeoff-card {
//             right: 5%;
//             bottom: 50px;
//           }

//           .sg-helmet {
//             right: 30%;
//           }

//           .sg-calculator {
//             right: 3%;
//           }

//           .sg-stats {
//             bottom: 15px;
//             width: 92%;
//             grid-template-columns: repeat(2, 1fr);
//             padding: 15px;
//           }

//           .sg-stat {
//             border-right: none;
//             border-bottom: 1px solid #e3e9f1;
//             padding: 10px;
//           }

//           .sg-stat:nth-last-child(-n+1) {
//             border-bottom: none;
//           }
//         }
//           .sg-division-icon {
//   font-size: 15px;
//   color: #1558c0;
//   flex-shrink: 0;
// }
//   .sg-btn-icon {
//   font-size: 18px;
//   flex-shrink: 0;
// }

//         @media (max-width: 500px) {
//           .sg-hero-inner {
//             padding-top: 60px;
//             padding-bottom: 360px;
//           }

//           .sg-title {
//             font-size: 42px;
//             line-height: 1.02;
//           }

//           .sg-description {
//             font-size: 15px;
//             line-height: 1.6;
//           }

//           .sg-btn {
//             width: 100%;
//           }

//           .sg-divisions {
//             gap: 6px;
//           }

//           .sg-division {
//             font-size: 10px;
//             padding: 7px 9px;
//           }

//           .sg-visual {
//             transform: scale(0.58);
//             bottom: 105px;
//           }

//           .sg-stats {
//             grid-template-columns: 1fr 1fr;
//           }

//           .sg-stat strong {
//             font-size: 17px;
//           }

//           .sg-stat span {
//             font-size: 9px;
//           }
//         }
//       `}</style>

//       <section className="sg-hero" id="home">
//         <div className="sg-blueprint"></div>

//         <div className="sg-hero-inner">

//           {/* LEFT CONTENT */}
//           <div className={`sg-content ${loaded ? "show" : ""}`}>

//             <div className="sg-eyebrow">
//               <span className="sg-eyebrow-dot"></span>
//               Construction Estimating Experts
//             </div>

//             <h1 className="sg-title">
//               Accurate Estimates.
//               <br />
//               Smarter <span>Bids.</span>
//               <br />
//               Stronger <span>Projects.</span>
//             </h1>

//             <p className="sg-description">
//               We deliver precise construction estimating and quantity
//               takeoff services that help contractors, builders, and
//               construction professionals bid confidently and understand
//               project costs before breaking ground.
//             </p>

//             <div className="sg-buttons">

//               <a href="#contact" className="sg-btn sg-btn-primary">
//                 <FiClipboard className="sg-btn-icon" />
//                 Request an Estimate
//               </a>

//               <a href="#services" className="sg-btn sg-btn-secondary">
//                 <FiArrowRight className="sg-btn-icon" />
//                 Explore Our Services
//               </a>

//             </div>

//             <div className="sg-divisions">
//               {divisions.map((division) => {
//                 const Icon = division.icon;

//                 return (
//                   <div className="sg-division" key={division.number}>
//                     <Icon className="sg-division-icon" />
//                     <strong>Div. {division.number}</strong>
//                     <span>{division.name}</span>
//                   </div>
//                 );
//               })}
//             </div>

//           </div>

//           {/* RIGHT VISUAL */}
//           <div className="sg-visual">

//             {/* Estimate Card */}
//             <div className="sg-estimate-card">
//               <div className="sg-card-heading">
//                 <div className="sg-card-icon"><FiFileText /></div>
//                 Project Estimate
//               </div>

//               <div className="sg-card-value">$2.48M</div>

//               <div className="sg-card-small">
//                 Estimated Total Project Cost
//               </div>

//               <div className="sg-chart">
//                 <i></i>
//                 <i></i>
//                 <i></i>
//                 <i></i>
//                 <i></i>
//                 <i></i>
//               </div>
//             </div>

//             {/* Takeoff Card */}
//             <div className="sg-takeoff-card">
//               <div className="sg-card-heading">
//                 <div className="sg-card-icon sg-orange-icon"><FiLayers /></div>
//                 Material Takeoff
//               </div>

//               <div className="sg-takeoff-number">
//                 1,284
//               </div>

//               <div className="sg-card-small">
//                 Total Items Quantified
//               </div>

//               <div className="sg-progress">
//                 <span></span>
//               </div>
//             </div>

//             {/* Helmet */}
//             {/* <div className="sg-helmet">
//               <div className="sg-helmet-top"></div>

//               <div className="sg-helmet-logo">
//                 STRUCTGUARD
//                 <br />
//                 CONSTRUCTION SERVICES LLP
//               </div>

//               <div className="sg-helmet-brim"></div>
//             </div> */}

//             {/* Calculator */}
//             <div className="sg-calculator">
//               <div className="sg-calculator-screen">
//                 2,480,000
//               </div>

//               <div className="sg-calculator-buttons">
//                 {[
//                   "7", "8", "9", "÷",
//                   "4", "5", "6", "×",
//                   "1", "2", "3", "-",
//                   "0", ".", "=", "+"
//                 ].map((item, index) => (
//                   <span key={index}>{item}</span>
//                 ))}
//               </div>
//             </div>

//           </div>
//         </div>

//         {/* STATS */}
//         <div className="sg-stats">

//           <div className="sg-stat">
//             <div className="sg-stat-icon">
//               <FiBarChart2 />
//             </div>
//             <div>
//               <strong>500+</strong>
//               <span>Projects Estimated</span>
//             </div>
//           </div>

//           <div className="sg-stat">
//             <div className="sg-stat-icon">
//               <FiUsers />
//             </div>
//             <div>
//               <strong>250+</strong>
//               <span>Contractors Served</span>
//             </div>
//           </div>

//           <div className="sg-stat">
//             <div className="sg-stat-icon">
//               <FiClock />
//             </div>
//             <div>
//               <strong>24–48 hrs</strong>
//               <span>Typical Turnaround</span>
//             </div>
//           </div>

//           <div className="sg-stat">
//             <div className="sg-stat-icon">
//               <FiGrid />
//             </div>
//             <div>
//               <strong>9+</strong>
//               <span>CSI Divisions Covered</span>
//             </div>
//           </div>

//           <div className="sg-stat">
//             <div className="sg-stat-icon">
//               <FiCheckCircle />
//             </div>
//             <div>
//               <strong>98%</strong>
//               <span>Client Satisfaction</span>
//             </div>
//           </div>

//         </div>
//       </section>
//     </>
//   );
// };

// export default LandingScreen;


import React, { useEffect, useState } from "react";
import {
  FiClipboard,
  FiArrowRight,
  FiFileText,
  FiLayers,
  FiBarChart2,
  FiUsers,
  FiClock,
  FiGrid,
  FiCheckCircle,
  FiHome,
  FiBox,
  FiSettings,
  FiDroplet,
  FiMaximize,
  FiEdit3,
  FiMap,
  FiCpu,
  FiTool,
  FiActivity,
  FiBriefcase,
} from "react-icons/fi";

const LandingScreen = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 150);

    return () => clearTimeout(timer);
  }, []);

  const divisions = [
    { number: "03", name: "Concrete", icon: FiHome },
    { number: "04", name: "Masonry", icon: FiBox },
    { number: "05", name: "Metals", icon: FiSettings },
    { number: "07", name: "Thermal & Moisture", icon: FiDroplet },
    { number: "08", name: "Openings", icon: FiMaximize },
    { number: "09", name: "Finishes", icon: FiEdit3 },
    { number: "32", name: "Exterior", icon: FiMap },
  ];

  const capabilities = [
    {
      icon: FiBarChart2,
      title: "Construction Estimating",
      text: "Accurate quantity takeoffs, material takeoffs, cost estimates and bid support.",
    },
    {
      icon: FiBriefcase,
      title: "Pre-Construction",
      text: "Budget development, scope review, preliminary estimates and value engineering support.",
    },
    {
      icon: FiCpu,
      title: "BIM Services",
      text: "BIM modeling, 3D coordination, clash detection and BIM-based quantity extraction.",
    },
    {
      icon: FiTool,
      title: "Project Engineering",
      text: "Engineering coordination, technical documentation, shop drawing review and project support.",
    },
  ];

  return (
    <>
      <style>{`
        * {
          box-sizing: border-box;
        }

        html {
          scroll-behavior: smooth;
        }

        body {
          margin: 0;
          font-family: Arial, Helvetica, sans-serif;
          background: #f8fbff;
          color: #10213f;
        }

        .sg-hero {
          position: relative;
          min-height: 820px;
          overflow: hidden;
          background:
            linear-gradient(
              90deg,
              rgba(255,255,255,0.98) 0%,
              rgba(255,255,255,0.96) 40%,
              rgba(255,255,255,0.52) 67%,
              rgba(255,255,255,0.12) 100%
            ),
            url("https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=2000&q=90");
          background-size: cover;
          background-position: center;
        }

        .sg-blueprint {
          position: absolute;
          inset: 0;
          pointer-events: none;
          opacity: 0.32;
          background-image:
            linear-gradient(rgba(20,78,150,0.07) 1px, transparent 1px),
            linear-gradient(90deg, rgba(20,78,150,0.07) 1px, transparent 1px);
          background-size: 42px 42px;
          mask-image: linear-gradient(
            90deg,
            black 0%,
            black 35%,
            transparent 72%
          );
        }

        .sg-blueprint::after {
          content: "";
          position: absolute;
          width: 500px;
          height: 500px;
          left: -150px;
          top: 180px;
          border: 1px solid rgba(20,78,150,0.12);
          transform: rotate(15deg);
        }

        .sg-hero-inner {
          position: relative;
          z-index: 2;
          width: min(1380px, 92%);
          min-height: 820px;
          margin: auto;
          display: flex;
          align-items: center;
          padding: 95px 0 175px;
        }

        .sg-content {
          width: 57%;
          padding-left: 20px;
          opacity: 0;
          transform: translateY(30px);
          transition: all 0.8s ease;
        }

        .sg-content.show {
          opacity: 1;
          transform: translateY(0);
        }

        .sg-eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 9px;
          margin-bottom: 21px;
          padding: 9px 15px;
          border-radius: 30px;
          background: rgba(30,92,190,0.08);
          border: 1px solid rgba(30,92,190,0.13);
          color: #1455b8;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 1.2px;
          text-transform: uppercase;
        }

        .sg-eyebrow-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #f39a18;
          animation: sgPulse 1.8s infinite;
        }

        .sg-title {
          max-width: 760px;
          margin: 0;
          font-size: clamp(46px, 5.1vw, 80px);
          line-height: 0.99;
          letter-spacing: -3.5px;
          font-weight: 800;
          color: #10213f;
        }

        .sg-title span {
          color: #1d5fc3;
        }

        .sg-description {
          max-width: 680px;
          margin: 27px 0 29px;
          color: #53627a;
          font-size: 17px;
          line-height: 1.7;
        }

        .sg-capabilities {
          display: grid;
          grid-template-columns: repeat(2, minmax(210px, 1fr));
          gap: 9px;
          max-width: 700px;
          margin-bottom: 27px;
        }

        .sg-capability {
          display: flex;
          align-items: center;
          gap: 10px;
          min-height: 46px;
          padding: 8px 12px;
          border: 1px solid rgba(22,74,140,0.11);
          border-radius: 9px;
          background: rgba(255,255,255,0.76);
          backdrop-filter: blur(8px);
          transition: all 0.25s ease;
        }

        .sg-capability:hover {
          transform: translateY(-2px);
          border-color: rgba(21,88,192,0.28);
          box-shadow: 0 8px 22px rgba(25,66,115,0.08);
        }

        .sg-capability-icon {
          width: 32px;
          height: 32px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 8px;
          background: #edf4ff;
          color: #1558c0;
          font-size: 16px;
        }

        .sg-capability:nth-child(2) .sg-capability-icon,
        .sg-capability:nth-child(4) .sg-capability-icon {
          background: #fff4e4;
          color: #e7870c;
        }

        .sg-capability strong {
          display: block;
          color: #243a5a;
          font-size: 12px;
          line-height: 1.25;
        }

        .sg-capability small {
          display: block;
          margin-top: 2px;
          color: #7a8799;
          font-size: 9px;
        }

        .sg-buttons {
          display: flex;
          gap: 14px;
          flex-wrap: wrap;
        }

        .sg-btn {
          border: none;
          text-decoration: none;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          min-height: 54px;
          padding: 0 25px;
          border-radius: 9px;
          font-size: 14px;
          font-weight: 700;
          letter-spacing: 0.2px;
          transition: all 0.25s ease;
        }

        .sg-btn-primary {
          color: white;
          background: linear-gradient(135deg, #1558c0, #2874dd);
          box-shadow: 0 12px 30px rgba(27,91,190,0.24);
        }

        .sg-btn-primary:hover {
          transform: translateY(-3px);
          box-shadow: 0 17px 35px rgba(27,91,190,0.30);
        }

        .sg-btn-secondary {
          color: #1455b8;
          background: rgba(255,255,255,0.88);
          border: 1px solid #c9d8ed;
        }

        .sg-btn-secondary:hover {
          transform: translateY(-3px);
          border-color: #1455b8;
          background: white;
        }

        .sg-btn-icon {
          font-size: 18px;
          flex-shrink: 0;
        }

        .sg-divisions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 27px;
          max-width: 720px;
        }

        .sg-division {
          display: flex;
          align-items: center;
          gap: 7px;
          padding: 7px 10px;
          border: 1px solid rgba(22,74,140,0.12);
          border-radius: 7px;
          background: rgba(255,255,255,0.72);
          color: #35445d;
          font-size: 11px;
          font-weight: 600;
          backdrop-filter: blur(8px);
        }

        .sg-division strong {
          color: #1455b8;
        }

        .sg-division-icon {
          font-size: 14px;
          color: #1558c0;
          flex-shrink: 0;
        }

        .sg-visual {
          position: absolute;
          right: -25px;
          top: 115px;
          width: 53%;
          height: 600px;
          pointer-events: none;
        }

        .sg-visual::after {
          content: "";
          position: absolute;
          right: 4%;
          bottom: 25px;
          width: 520px;
          height: 80px;
          background: rgba(255,255,255,0.35);
          filter: blur(28px);
          border-radius: 50%;
        }

        .sg-estimate-card {
          position: absolute;
          z-index: 5;
          top: 55px;
          left: 0;
          width: 235px;
          padding: 20px;
          border: 1px solid rgba(255,255,255,0.8);
          border-radius: 18px;
          background: rgba(255,255,255,0.91);
          box-shadow: 0 22px 55px rgba(16,43,82,0.17);
          backdrop-filter: blur(14px);
          animation: sgFloat 4s ease-in-out infinite;
        }

        .sg-card-heading {
          display: flex;
          align-items: center;
          gap: 11px;
          color: #647188;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.7px;
          text-transform: uppercase;
        }

        .sg-card-icon {
          width: 38px;
          height: 38px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 10px;
          color: white;
          background: #175bc3;
          font-size: 19px;
          flex-shrink: 0;
        }

        .sg-card-icon svg {
          width: 19px;
          height: 19px;
          stroke-width: 2;
        }

        .sg-card-value {
          margin-top: 15px;
          color: #1558c0;
          font-size: 29px;
          font-weight: 800;
        }

        .sg-card-small {
          margin-top: 4px;
          color: #8490a3;
          font-size: 11px;
        }

        .sg-chart {
          display: flex;
          align-items: flex-end;
          gap: 6px;
          height: 38px;
          margin-top: 15px;
        }

        .sg-chart i {
          display: block;
          width: 10px;
          border-radius: 3px 3px 0 0;
          background: #2770d5;
          animation: sgChart 2s ease-in-out infinite alternate;
        }

        .sg-chart i:nth-child(1) {
          height: 12px;
        }

        .sg-chart i:nth-child(2) {
          height: 18px;
          animation-delay: .1s;
        }

        .sg-chart i:nth-child(3) {
          height: 15px;
          animation-delay: .2s;
        }

        .sg-chart i:nth-child(4) {
          height: 24px;
          animation-delay: .3s;
        }

        .sg-chart i:nth-child(5) {
          height: 21px;
          animation-delay: .4s;
        }

        .sg-chart i:nth-child(6) {
          height: 31px;
          animation-delay: .5s;
        }

        .sg-takeoff-card {
          position: absolute;
          z-index: 6;
          right: 7%;
          bottom: 80px;
          width: 215px;
          padding: 19px;
          border-radius: 17px;
          background: rgba(255,255,255,0.94);
          box-shadow: 0 22px 55px rgba(16,43,82,0.17);
          backdrop-filter: blur(14px);
          animation: sgFloat 4.5s ease-in-out infinite;
          animation-delay: 0.8s;
        }

        .sg-orange-icon {
          background: #f39818;
        }

        .sg-takeoff-number {
          margin-top: 12px;
          color: #e7870c;
          font-size: 27px;
          font-weight: 800;
        }

        .sg-progress {
          height: 7px;
          margin-top: 14px;
          border-radius: 20px;
          overflow: hidden;
          background: #e8edf4;
        }

        .sg-progress span {
          display: block;
          width: 88%;
          height: 100%;
          border-radius: inherit;
          background: linear-gradient(90deg, #f39818, #ffbd4d);
          animation: sgProgress 2.5s ease;
        }

        /* BIM floating card */

        .sg-bim-card {
          position: absolute;
          z-index: 5;
          right: 20%;
          top: 185px;
          width: 185px;
          padding: 15px;
          border: 1px solid rgba(255,255,255,0.9);
          border-radius: 15px;
          background: rgba(255,255,255,0.91);
          box-shadow: 0 20px 45px rgba(16,43,82,0.14);
          backdrop-filter: blur(14px);
          animation: sgFloat 5s ease-in-out infinite;
          animation-delay: 0.4s;
        }

        .sg-bim-icon {
          width: 36px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 9px;
          background: #edf4ff;
          color: #1558c0;
          font-size: 18px;
        }

        .sg-bim-title {
          margin-top: 10px;
          color: #243a5a;
          font-size: 13px;
          font-weight: 800;
        }

        .sg-bim-text {
          margin-top: 4px;
          color: #7d899a;
          font-size: 9px;
          line-height: 1.5;
        }

        .sg-bim-lines {
          margin-top: 10px;
          display: grid;
          gap: 4px;
        }

        .sg-bim-lines span {
          display: block;
          height: 4px;
          border-radius: 5px;
          background: #dbe7f7;
        }

        .sg-bim-lines span:nth-child(2) {
          width: 76%;
        }

        .sg-bim-lines span:nth-child(3) {
          width: 55%;
        }

        /* Calculator */

        .sg-calculator {
          position: absolute;
          z-index: 5;
          right: -10px;
          bottom: 0;
          width: 155px;
          height: 180px;
          padding: 15px;
          border-radius: 12px;
          background: linear-gradient(145deg, #303945, #151c25);
          transform: rotate(5deg);
          box-shadow: 0 25px 40px rgba(15,32,52,0.28);
        }

        .sg-calculator-screen {
          height: 40px;
          padding: 10px;
          border-radius: 5px;
          background: #cbd5b7;
          color: #273020;
          text-align: right;
          font-size: 14px;
          font-weight: 700;
        }

        .sg-calculator-buttons {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 5px;
          margin-top: 10px;
        }

        .sg-calculator-buttons span {
          height: 22px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 3px;
          background: #4a5562;
          color: white;
          font-size: 8px;
        }

        /* Bottom stats */

        .sg-stats {
          position: absolute;
          z-index: 10;
          left: 50%;
          bottom: 25px;
          transform: translateX(-50%);
          width: min(1250px, 90%);
          padding: 20px 25px;
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 10px;
          border: 1px solid rgba(213,224,237,0.9);
          border-radius: 18px;
          background: rgba(255,255,255,0.93);
          box-shadow: 0 18px 50px rgba(35,63,96,0.12);
          backdrop-filter: blur(16px);
        }

        .sg-stat {
          min-height: 55px;
          padding: 0 15px;
          display: flex;
          align-items: center;
          gap: 12px;
          border-right: 1px solid #e3e9f1;
        }

        .sg-stat:last-child {
          border-right: none;
        }

        .sg-stat-icon {
          width: 39px;
          height: 39px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: #edf4ff;
          color: #1558c0;
          font-size: 18px;
        }

        .sg-stat strong {
          display: block;
          color: #10213f;
          font-size: 21px;
        }

        .sg-stat span {
          display: block;
          margin-top: 3px;
          color: #7b8799;
          font-size: 10px;
        }

        @keyframes sgFloat {
          0%, 100% {
            transform: translateY(0);
          }

          50% {
            transform: translateY(-13px);
          }
        }

        @keyframes sgPulse {
          0%, 100% {
            box-shadow: 0 0 0 0 rgba(243,152,24,0.3);
          }

          50% {
            box-shadow: 0 0 0 7px rgba(243,152,24,0);
          }
        }

        @keyframes sgChart {
          from {
            opacity: 0.55;
            transform: scaleY(0.75);
          }

          to {
            opacity: 1;
            transform: scaleY(1);
          }
        }

        @keyframes sgProgress {
          from {
            width: 0;
          }

          to {
            width: 88%;
          }
        }

        @media (max-width: 1200px) {
          .sg-content {
            width: 63%;
          }

          .sg-visual {
            opacity: 0.72;
            right: -150px;
          }

          .sg-capabilities {
            max-width: 650px;
          }
        }

        @media (max-width: 1100px) {
          .sg-title {
            font-size: clamp(43px, 5.2vw, 68px);
          }

          .sg-description {
            max-width: 610px;
          }

          .sg-stats {
            grid-template-columns: repeat(3, 1fr);
          }

          .sg-stat:nth-child(3) {
            border-right: none;
          }
        }

        @media (max-width: 800px) {
          .sg-hero {
            min-height: auto;
            background:
              linear-gradient(
                180deg,
                rgba(255,255,255,0.97) 0%,
                rgba(255,255,255,0.91) 60%,
                rgba(255,255,255,0.75) 100%
              ),
              url("https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=1400&q=85");
            background-position: center;
          }

          .sg-hero-inner {
            min-height: auto;
            padding: 78px 0 410px;
          }

          .sg-content {
            width: 100%;
            padding: 0;
            text-align: center;
          }

          .sg-eyebrow {
            margin-bottom: 18px;
          }

          .sg-title {
            font-size: clamp(42px, 11vw, 65px);
            letter-spacing: -2.5px;
          }

          .sg-description {
            margin-left: auto;
            margin-right: auto;
            font-size: 16px;
          }

          .sg-capabilities {
            grid-template-columns: 1fr 1fr;
            max-width: 650px;
            margin-left: auto;
            margin-right: auto;
            text-align: left;
          }

          .sg-buttons {
            justify-content: center;
          }

          .sg-divisions {
            justify-content: center;
          }

          .sg-visual {
            top: auto;
            right: 0;
            bottom: 100px;
            width: 100%;
            height: 285px;
            transform: scale(0.72);
            transform-origin: bottom center;
            opacity: 0.9;
          }

          .sg-estimate-card {
            left: 5%;
            top: 15px;
          }

          .sg-bim-card {
            right: 30%;
            top: 100px;
          }

          .sg-takeoff-card {
            right: 5%;
            bottom: 50px;
          }

          .sg-calculator {
            right: 3%;
          }

          .sg-stats {
            bottom: 15px;
            width: 92%;
            grid-template-columns: repeat(2, 1fr);
            padding: 15px;
          }

          .sg-stat {
            border-right: none;
            border-bottom: 1px solid #e3e9f1;
            padding: 10px;
          }

          .sg-stat:nth-child(4) {
            border-bottom: none;
          }

          .sg-stat:nth-child(5) {
            grid-column: 1 / -1;
            border-bottom: none;
          }
        }

        @media (max-width: 560px) {
          .sg-capabilities {
            grid-template-columns: 1fr;
          }

          .sg-capability {
            justify-content: flex-start;
          }

          .sg-division {
            font-size: 10px;
            padding: 7px 9px;
          }

          .sg-visual {
            transform: scale(0.61);
            bottom: 105px;
          }
        }

        @media (max-width: 500px) {
          .sg-hero-inner {
            padding-top: 60px;
            padding-bottom: 390px;
          }

          .sg-title {
            font-size: 42px;
            line-height: 1.02;
          }

          .sg-description {
            font-size: 15px;
            line-height: 1.6;
          }

          .sg-btn {
            width: 100%;
          }

          .sg-divisions {
            gap: 6px;
          }

          .sg-division {
            font-size: 10px;
            padding: 7px 9px;
          }

          .sg-visual {
            transform: scale(0.55);
            bottom: 108px;
          }

          .sg-stats {
            grid-template-columns: 1fr 1fr;
          }

          .sg-stat strong {
            font-size: 17px;
          }

          .sg-stat span {
            font-size: 9px;
          }
        }

        @media (max-width: 380px) {
          .sg-title {
            font-size: 38px;
          }

          .sg-eyebrow {
            font-size: 10px;
          }

          .sg-capability strong {
            font-size: 11px;
          }

          .sg-capability small {
            font-size: 8px;
          }

          .sg-visual {
            transform: scale(0.48);
          }
        }
      `}</style>

      <section className="sg-hero" id="home">
        <div className="sg-blueprint"></div>

        <div className="sg-hero-inner">

          {/* LEFT CONTENT */}
          <div className={`sg-content ${loaded ? "show" : ""}`}>

            <div className="sg-eyebrow">
              <span className="sg-eyebrow-dot"></span>
              Construction Services & Technical Solutions
            </div>

            <h1 className="sg-title">
              Build With
              <br />
              Better <span>Data.</span>
              <br />
              Stronger <span>Projects.</span>
            </h1>

            <p className="sg-description">
              StructGuard Construction Services LLP supports contractors,
              builders, developers, and construction professionals with
              accurate estimating, pre-construction planning, BIM services,
              and project engineering support from early planning through
              project delivery.
            </p>

            {/* FOUR MAIN CAPABILITIES */}
            <div className="sg-capabilities">

              {capabilities.map((item, index) => {
                const Icon = item.icon;

                return (
                  <div
                    className="sg-capability"
                    key={index}
                  >
                    <div className="sg-capability-icon">
                      <Icon />
                    </div>

                    <div>
                      <strong>{item.title}</strong>
                      <small>{item.text}</small>
                    </div>
                  </div>
                );
              })}

            </div>

            {/* BUTTONS */}
            <div className="sg-buttons">

              <a
                href="#contact"
                className="sg-btn sg-btn-primary"
              >
                <FiClipboard className="sg-btn-icon" />
                Request a Consultation
              </a>

              <a
                href="#services"
                className="sg-btn sg-btn-secondary"
              >
                <FiArrowRight className="sg-btn-icon" />
                Explore Our Services
              </a>

            </div>

            {/* CSI DIVISIONS */}
            <div className="sg-divisions">

              {divisions.map((division) => {
                const Icon = division.icon;

                return (
                  <div
                    className="sg-division"
                    key={division.number}
                  >
                    <Icon className="sg-division-icon" />

                    <strong>
                      Div. {division.number}
                    </strong>

                    <span>
                      {division.name}
                    </span>
                  </div>
                );
              })}

            </div>

          </div>

          {/* RIGHT VISUAL */}
          <div className="sg-visual">

            {/* ESTIMATE CARD */}
            <div className="sg-estimate-card">

              <div className="sg-card-heading">

                <div className="sg-card-icon">
                  <FiFileText />
                </div>

                Project Estimate

              </div>

              <div className="sg-card-value">
                $2.48M
              </div>

              <div className="sg-card-small">
                Estimated Total Project Cost
              </div>

              <div className="sg-chart">
                <i></i>
                <i></i>
                <i></i>
                <i></i>
                <i></i>
                <i></i>
              </div>

            </div>

            {/* BIM CARD */}
            <div className="sg-bim-card">

              <div className="sg-bim-icon">
                <FiCpu />
              </div>

              <div className="sg-bim-title">
                BIM Coordination
              </div>

              <div className="sg-bim-text">
                Model-based coordination and project information.
              </div>

              <div className="sg-bim-lines">
                <span></span>
                <span></span>
                <span></span>
              </div>

            </div>

            {/* TAKEOFF CARD */}
            <div className="sg-takeoff-card">

              <div className="sg-card-heading">

                <div className="sg-card-icon sg-orange-icon">
                  <FiLayers />
                </div>

                Material Takeoff

              </div>

              <div className="sg-takeoff-number">
                1,284
              </div>

              <div className="sg-card-small">
                Total Items Quantified
              </div>

              <div className="sg-progress">
                <span></span>
              </div>

            </div>

            {/* CALCULATOR */}
            <div className="sg-calculator">

              <div className="sg-calculator-screen">
                2,480,000
              </div>

              <div className="sg-calculator-buttons">

                {[
                  "7", "8", "9", "÷",
                  "4", "5", "6", "×",
                  "1", "2", "3", "-",
                  "0", ".", "=", "+"
                ].map((item, index) => (
                  <span key={index}>
                    {item}
                  </span>
                ))}

              </div>

            </div>

          </div>
        </div>

        {/* STATS */}
        <div className="sg-stats">

          <div className="sg-stat">

            <div className="sg-stat-icon">
              <FiBarChart2 />
            </div>

            <div>
              <strong>500+</strong>
              <span>Projects Supported</span>
            </div>

          </div>

          <div className="sg-stat">

            <div className="sg-stat-icon">
              <FiUsers />
            </div>

            <div>
              <strong>250+</strong>
              <span>Contractors Served</span>
            </div>

          </div>

          <div className="sg-stat">

            <div className="sg-stat-icon">
              <FiClock />
            </div>

            <div>
              <strong>24–48 hrs</strong>
              <span>Typical Estimating Turnaround</span>
            </div>

          </div>

          <div className="sg-stat">

            <div className="sg-stat-icon">
              <FiGrid />
            </div>

            <div>
              <strong>9+</strong>
              <span>CSI Divisions Covered</span>
            </div>

          </div>

          <div className="sg-stat">

            <div className="sg-stat-icon">
              <FiCheckCircle />
            </div>

            <div>
              <strong>4</strong>
              <span>Core Service Areas</span>
            </div>

          </div>

        </div>

      </section>
    </>
  );
};

export default LandingScreen;